import { handleActions } from 'redux-actions';

export default handleActions({}, {});



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/configuration.js